import { FormTemplate } from 'data/template/template.types';

const targetDeliveryTemplateEricssonNE: FormTemplate = {
  version: '1.0.0',
  name: 'Ericsson NE',
  key: 'ERICSSON_NE',
  main: {
    metadata: {
      layout: {
        rows: [['id'], ['name', 'afType', 'afId']]
      }
    },
    fields: {
      id: {
        type: 'text',
        initial: '',
        hide: 'true'
      },
      name: {
        label: 'Template Name',
        type: 'text',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?/'],
              errorMessage:
                'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?/. Please re-enter.'
            },
            {
              type: 'length',
              length: 32,
              errorMessage: 'Exceeds maximum length, 32.  Please re-enter.'
            }
          ]
        }
      },
      afType: {
        label: 'AF Type',
        type: 'select',
        initial: '',
        options: [],
        validation: {
          required: true
        }
      },
      afId: {
        label: 'Access Function Name',
        type: 'select',
        initial: '',
        options: [
          {
            label: 'Select an Accesss Function',
            value: ''
          }
        ],
        validation: {
          required: true
        }
      }
    }
  },
  EIMSGENERAL: {
    metadata: {
      layout: {
        rows: [['netype', '$empty', '$empty']]
      }
    },
    fields: {
      netype: {
        label: 'Type',
        type: 'select',
        initial: 'GPRS',
        options: [
          {
            label: 'MSC',
            value: 'MSC'
          },
          {
            label: 'HLR',
            value: 'HLR'
          },
          {
            label: 'FIX',
            value: 'FIX'
          },
          {
            label: 'GPRS',
            value: 'GPRS'
          },
          {
            label: 'SIPSERVER',
            value: 'SIPSERVER'
          },
          {
            label: 'OV_SIPSERVER',
            value: 'OV_SIPSERVER'
          },
          {
            label: 'OV_MOWLAN',
            value: 'OV_MOWLAN'
          },
          {
            label: 'OV_GPRS',
            value: 'OV_GPRS'
          }
        ],
        affectedFieldsOnChange: ['resversion']
      }
    }
  },
  EIMSTARGET: {
    metadata: {
      layout: {
        rows: [
          ['TID', 'AFID', 'NETOPID', 'SUBNETOPID', 'LEAID'],
          ['WARRANTID', 'LEMFID', 'SUPP_INFO'],
          ['USEONELEMF']
        ]
      }
    },
    fields: {
      TID: {
        type: 'text',
        hide: 'true',
        initial: ''
      },
      AFID: {
        type: 'text',
        hide: 'true',
        initial: ''
      },
      NETOPID: {
        label: 'Network Operator ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 20
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage:
                'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.'
            }
          ]
        }
      },
      SUBNETOPID: {
        label: 'Subnetwork Operator ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 20
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage:
                'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.'
            }
          ]
        }
      },
      LEAID: {
        label: 'LEA ID',
        type: 'text',
        initial: 'XCIPIO',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 10
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage:
                'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.'
            }
          ]
        }
      },
      WARRANTID: {
        label: 'Warrant ID',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 10
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage:
                'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.'
            }
          ]
        }
      },
      LEMFID: {
        label: 'LEMF ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 10
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage:
                'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.'
            }
          ]
        }
      },
      USEONELEMF: {
        label: 'Use one LEMF',
        type: 'checkbox',
        initial: false
      },
      SUPP_INFO: {
        label: 'SUPP INFO',
        type: 'text',
        initial: '',
        placeholder: 'Please enter a number between 0 and 65535',
        validation: {
          required: false,
          validators: [
            {
              type: 'length',
              length: 5
            },
            {
              type: 'regexp',
              regexp: ['digits'],
              errorMessage:
                'Can only include digits. Please re-enter.'
            },
            {
              type: 'customFunction',
              customValidationFunction: 'shortIntValidator',
              errorMessage: 'Value must be between 0 and 65535.'
            }
          ]
        }
      }
    }
  },
  EIMSGPRSTRGT: {
    metadata: {
      layout: {
        rows: [['TID', 'AFID', 'GGSNMONITOR', 'SUPP_LOCINFO', '$empty']]
      }
    },
    fields: {
      TID: {
        type: 'text',
        hide: 'true',
        initial: ''
      },
      AFID: {
        type: 'text',
        hide: 'true',
        initial: ''
      },
      GGSNMONITOR: {
        label: 'GGNS Monitor',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE'
          },
          {
            label: 'False',
            value: 'FALSE'
          }
        ]
      },
      SUPP_LOCINFO: {
        label: 'LIPA',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE'
          },
          {
            label: 'False',
            value: 'FALSE'
          }
        ]
      }
    }
  },
  EIMSMCNB: {
    metadata: {
      min: 1,
      max: 10,
      layout: {
        rows: [
          ['TID', 'AFID', 'MCNBID', 'MCNB', 'MCNBTYPE'],
          ['MCNBNAME', 'SECMASMCNB_ID', 'DESCRIPTION'],
          ['HI3NAME', 'HOSTNAME', 'CHANNELNUM'],
          ['MCNBPORT', '$empty', '$empty']
        ]
      }
    },
    fields: {
      TID: {
        type: 'text',
        hide: 'true',
        initial: ''
      },
      AFID: {
        type: 'text',
        hide: 'true',
        initial: ''
      },
      MCNBID: {
        label: 'MCNBID',
        type: 'select',
        initial: '1',
        options: [
          {
            label: '1',
            value: '1'
          },
          {
            label: '2',
            value: '2'
          },
          {
            label: '3',
            value: '3'
          },
          {
            label: '4',
            value: '4'
          },
          {
            label: '5',
            value: '5'
          },
          {
            label: '6',
            value: '6'
          },
          {
            label: '7',
            value: '7'
          },
          {
            label: '8',
            value: '8'
          },
          {
            label: '9',
            value: '9'
          },
          {
            label: '10',
            value: '10'
          }
        ]
      },
      MCNB: {
        label: 'MCNB',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 32
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage:
                'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.'
            }
          ]
        }
      },
      MCNBTYPE: {
        label: 'MCNBTYPE',
        type: 'select',
        initial: 'IP',
        options: [
          {
            label: 'IP',
            value: 'IP'
          },
          {
            label: 'PDHIR',
            value: 'PDHIR'
          }
        ]
      },
      MCNBNAME: {
        label: 'MCNBNAME',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 60
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage:
                'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.'
            }
          ]
        }
      },
      SECMASMCNB_ID: {
        label: 'Second MCNB ID',
        type: 'text',
        initial: '0',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 10
            },
            {
              type: 'Interval',
              intervals: [[0, 9999999999]],
              errorMessage: 'Must be between 0 - 9999999999. Please re-enter.'
            }
          ]
        }
      },
      DESCRIPTION: {
        label: 'Description',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 50
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage:
                'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.'
            }
          ]
        }
      },
      HI3NAME: {
        label: 'HI3 Name',
        type: 'select',
        initial: 'LIS5-HI3-3GPPr7-Wless-PS_v1',
        options: [
          {
            label: 'LIS5-HI3-3GPPr7-Wless-PS_v0',
            value: 'LIS5-HI3-3GPPr7-Wless-PS_v0'
          },
          {
            label: 'LIS5-HI3-3GPPr7-Wless-PS_v1',
            value: 'LIS5-HI3-3GPPr7-Wless-PS_v1'
          },
          {
            label: 'LIS5-e3-ANSI678-IMS',
            value: 'LIS5-e3-ANSI678-IMS'
          },
          {
            label: 'LIS6-HI3-3GPPr8-Wless-EPS_v1',
            value: 'LIS6-HI3-3GPPr8-Wless-EPS_v1'
          },
          {
            label: 'LIS7-HI3-ETSI232-5',
            value: 'LIS7-HI3-ETSI232-5'
          },
          {
            label: 'LIS13-HI3-3GPPr10-Wless-EPS_v1',
            value: 'LIS13-HI3-3GPPr10-Wless-EPS_v1'
          },
          {
            label: 'LIS13-e3-ATIS0700005a',
            value: 'LIS13-e3-ATIS0700005a'
          },
          {
            label: 'LIS14-HI3-ETSI232-5',
            value: 'LIS14-HI3-ETSI232-5'
          },
          {
            label: 'LIS14-HI3-3GPPr12-VoLTE-Conf',
            value: 'LIS14-HI3-3GPPr12-VoLTE-Conf'
          },
          {
            label: 'LIS16-HI3-ETSI232-5',
            value: 'LIS16-HI3-ETSI232-5'
          },
          {
            label: 'LIIMS3-HI3-3GPPr16-VoLTE-Conf',
            value: 'LIIMS3-HI3-3GPPr16-VoLTE-Conf'
          }
        ]
      },
      HOSTNAME: {
        label: 'Host Name',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 50
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', 'spaces', '-_.~!@#$%^*+?'],
              errorMessage:
                'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.'
            }
          ]
        }
      },
      CHANNELNUM: {
        label: 'Channel Number',
        type: 'text',
        initial: '0',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5
            },
            {
              type: 'Interval',
              intervals: [[0, 65535]],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.'
            }
          ]
        }
      },
      MCNBPORT: {
        label: 'MCNB Port',
        type: 'text',
        initial: '45001',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5
            },
            {
              type: 'Interval',
              intervals: [[0, 65535]],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.'
            }
          ]
        }
      }
    }
  },
  EIMSWRLNTRGT: {
    metadata: {
      layout: {
        rows: [
          ['TID', 'AFID', 'LEGALBASIS', '$empty', '$empty'],
          ['CLOSEUSERGROUP', 'NTWKID', 'NUMSUPPRESSED'],
          ['VERIFYMCNB', 'PABXNAME', 'CTYPE'],
          ['MAXCALL', '$empty', '$empty']
        ]
      },
      hide: 'true'
    },
    fields: {
      TID: {
        type: 'text',
        hide: 'true',
        initial: ''
      },
      AFID: {
        type: 'text',
        hide: 'true',
        initial: ''
      },
      LEGALBASIS: {
        label: 'Legal Basis',
        type: 'select',
        initial: 'AWG',
        options: [
          {
            label: 'AWG',
            value: 'AWG'
          },
          {
            label: 'G10',
            value: 'G10'
          },
          {
            label: 'STP0',
            value: 'STP0'
          }
        ]
      },
      CLOSEUSERGROUP: {
        label: 'X.25 Close User Group',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 5
            },
            {
              type: 'Interval',
              intervals: [[0, 65535]],
              errorMessage: 'Must be between 0 - 65535. Please re-enter.'
            }
          ]
        }
      },
      NTWKID: {
        label: 'X.25 ID',
        type: 'text',
        initial: ''
      },
      NUMSUPPRESSED: {
        label: 'Number Suppression',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE'
          },
          {
            label: 'False',
            value: 'FALSE'
          }
        ]
      },
      VERIFYMCNB: {
        label: 'MCNB Validation',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE'
          },
          {
            label: 'False',
            value: 'FALSE'
          }
        ]
      },
      PABXNAME: {
        label: 'PABX Name',
        type: 'text',
        initial: ''
      },
      CTYPE: {
        label: 'CType',
        type: 'select',
        initial: 'ALL',
        options: [
          {
            label: 'ALL',
            value: 'ALL'
          },
          {
            label: 'TERM',
            value: 'TERM'
          },
          {
            label: 'ORIG',
            value: 'ORIG'
          }
        ]
      },
      MAXCALL: {
        label: 'Max Call',
        type: 'text',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 4
            },
            {
              type: 'Interval',
              intervals: [[1, 4095]],
              errorMessage: 'Must be between 1 - 4095. Please re-enter.'
            }
          ]
        }
      }
    }
  },
  EIMSMSCTRGT: {
    metadata: {
      hide: 'true',
      layout: {
        rows: [
          [
            'TID',
            'AFID',
          ],
          [
            'SUPP_LOCINFO',
            'SF_USSD',
          ],
          [
            'SF_HOI',
            'SF_NCIS',
          ],
          [
            'SF_CRSS',
            'SF_IOBS',
          ],
          [
            'SF_DDE',
            'DT_DFA',
          ],
          [
            'SF_LCUP',
            'DT_VCE',
          ],
          [
            'SF_CISS',
            'DT_UDI',
          ],
          [
            'SF_NCRS',
            'DT_AVF',
          ],
          [
            'SF_AVMC',
            'DT_F31',
          ],
        ],
      },
    },
    fields: {
      TID: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      AFID: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      SUPP_LOCINFO: {
        label: 'LIPA',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE',
          },
          {
            label: 'False',
            value: 'FALSE',
          },
        ],
      },
      SF_USSD: {
        label: 'SF_USSD',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE',
          },
          {
            label: 'False',
            value: 'FALSE',
          },
        ],
      },
      SF_HOI: {
        label: 'SF_HOI',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE',
          },
          {
            label: 'False',
            value: 'FALSE',
          },
        ],
      },
      SF_NCIS: {
        label: 'SF_NCIS',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE',
          },
          {
            label: 'False',
            value: 'FALSE',
          },
        ],
      },
      SF_CRSS: {
        label: 'SF_CRSS',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE',
          },
          {
            label: 'False',
            value: 'FALSE',
          },
        ],
      },
      SF_IOBS: {
        label: 'SF_IOBS',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE',
          },
          {
            label: 'False',
            value: 'FALSE',
          },
        ],
      },
      SF_DDE: {
        label: 'SF_DDE',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE',
          },
          {
            label: 'False',
            value: 'FALSE',
          },
        ],
      },
      DT_DFA: {
        label: 'DT_DFA',
        type: 'select',
        initial: 'NONE',
        options: [
          {
            label: 'None',
            value: 'NONE',
          },
          {
            label: '1',
            value: '1',
          },
          {
            label: '2',
            value: '2',
          },
        ],
      },
      SF_LCUP: {
        label: 'SF_LCUP',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE',
          },
          {
            label: 'False',
            value: 'FALSE',
          },
        ],
      },
      DT_VCE: {
        label: 'DT_VCE',
        type: 'select',
        initial: 'NONE',
        options: [
          {
            label: 'None',
            value: 'NONE',
          },
          {
            label: '1',
            value: '1',
          },
          {
            label: '2',
            value: '2',
          },
        ],
      },
      SF_CISS: {
        label: 'SF_CISS',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE',
          },
          {
            label: 'False',
            value: 'FALSE',
          },
        ],
      },
      DT_UDI: {
        label: 'DT_UDI',
        type: 'select',
        initial: 'NONE',
        options: [
          {
            label: 'None',
            value: 'NONE',
          },
          {
            label: '1',
            value: '1',
          },
          {
            label: '2',
            value: '2',
          },
        ],
      },
      SF_NCRS: {
        label: 'SF_NCRS',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE',
          },
          {
            label: 'False',
            value: 'FALSE',
          },
        ],
      },
      DT_AVF: {
        label: 'DT_AVF',
        type: 'select',
        initial: 'NONE',
        options: [
          {
            label: 'None',
            value: 'NONE',
          },
          {
            label: '1',
            value: '1',
          },
          {
            label: '2',
            value: '2',
          },
        ],
      },
      SF_AVMC: {
        label: 'SF_AVMC',
        type: 'select',
        initial: 'FALSE',
        options: [
          {
            label: 'True',
            value: 'TRUE',
          },
          {
            label: 'False',
            value: 'FALSE',
          },
        ],
      },
      DT_F31: {
        label: 'DT_F31',
        type: 'select',
        initial: 'NONE',
        options: [
          {
            label: 'None',
            value: 'NONE',
          },
          {
            label: '1',
            value: '1',
          },
          {
            label: '2',
            value: '2',
          },
        ],
      },
    },
  },
  EIMSMC: {
    metadata: {
      hide: 'true',
      layout: {
        rows: [
          [
            'IRI_MCID',
            'IRI_SUPPNEID',
          ],
          [
            'CC_MCID',
            'CC_SUPPNEID',
          ]
        ],
      },
    },
    fields: {
      IRI_MCID: {
        label: 'IRI MC ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: [
                'digits',
              ],
              errorMessage: 'Can include digits only. Please re-enter.'
            },
          ]
        }
      },
      IRI_SUPPNEID: {
        label: 'IRI MC SuppNeID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: [
                'digits',
              ],
              errorMessage: 'Can include digits only. Please re-enter.'
            },
          ]
        }
      },
      CC_MCID: {
        label: 'CC MC ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: [
                'digits',
              ],
              errorMessage: 'Can include digits only. Please re-enter.'
            },
          ]
        }
      },
      CC_SUPPNEID: {
        label: 'IRI MC SuppNeID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'regexp',
              regexp: [
                'digits',
              ],
              errorMessage: 'Can include digits only. Please re-enter.'
            },
          ]
        }
      },
    },
  }
};

export default targetDeliveryTemplateEricssonNE;
